"use client";

import { useState } from "react";
import { Minus, Plus } from "lucide-react";
import { faqSectionDict } from "@/types/dictionary";

export function FaqSection({ dict }: { dict: faqSectionDict }) {
    const {
        title = "Common Questions About WhatsAI, the AI agent",
        faqs = [
            {
                question: "How much does it cost?",
                answer: "Our pricing includes an initial setup fee for generating the AI model based on your company's data, which varies depending on the complexity and volume of information provided. After setup, subscription plans start from $20 per month."
            },
            {
                question: "How long does the setup process take?",
                answer: "The AI chatbot can be operational within one week, depending on the complexity of your data and specific requirements."
            },
            {
                question: "Can I monitor the chatbot's conversations?",
                answer: "Yes, you can monitor all interactions through WhatsApp Web, ensuring transparency and quality control."
            },
            {
                question: "Is it possible to schedule messages for customers?",
                answer: "Absolutely! You can schedule messages to be sent to customers at predetermined times, enhancing engagement and communication strategies."
            },
            {
                question: "Can I customize the AI's responses?",
                answer: "Yes, the AI's responses are based on the data and files you provide. You can update this information anytime to ensure the chatbot delivers accurate and relevant answers."
            },
            {
                question: "What happens if a customer wants to speak with a human representative?",
                answer: "If a customer requests human assistance, the conversation can be seamlessly forwarded to a human agent, complete with the full chat history for context."
            },
            {
                question: "Does the chatbot integrate with my CRM system?",
                answer: "Yes, our solution supports integration with several CRM systems, allowing for seamless data synchronization and efficient customer relationship management."
            },
            {
                question: "Is the AI capable of understanding multiple languages?",
                answer: "Yes, our AI chatbot supports multiple languages, enabling you to cater to a diverse customer base."
            },
            {
                question: "How secure is the data handled by the chatbot?",
                answer: "We prioritize data security and comply with industry-standard encryption protocols to protect all customer interactions and information."
            }
        ],
    } = dict || {};
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="sm:mt-5 mt-1 bg-background p-3 sm:py-10 mb-10 w-full">
      <h3 className="text-center text-foreground font-bold sm:text-2xl text-[1.8rem] mb-10">
        {title}
      </h3>
      <div className="flex flex-col gap-4 max-w-4xl mx-auto">
        {faqs.map((item, index) => (
          <div
            key={index}
            className="border-b border-gray-600 pb-4 cursor-pointer px-2 sm:px-0"
            onClick={() => toggle(index)}
          >
            <div className="flex justify-between items-center">
              <p className="text-start w-[90%] text-[1rem] sm:text-[1.2rem] font-medium text-foreground">
                {item.question}
              </p>
              {openIndex === index ? (
                <Minus className="text-foreground w-5 h-5" />
              ) : (
                <Plus className="text-foreground w-5 h-5" />
              )}
            </div>
            {openIndex === index && (
              <p
                className="text-gray3 mt-3 text-sm sm:text-base leading-relaxed [&_a]:text-purple1 [&_a]:underline [&_a]:hover:text-purple2"
                dangerouslySetInnerHTML={{ __html: item.answer }}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}